export default {
  sizes: { container: 640 },
  fonts: {
    heading: 'gorditas',
    body: 'inder',
    mono: '',
  },
  styles: {
    h1: {
      fontSize: '3rem',
      textAlign: 'center',
      fontFamily: 'body',
    },
    h2: {
      fontSize: '4rem',
      textTransform: 'capitalize',
      textAlign: 'center',
      height: '4rem',
      fontFamily: 'gorditas',
    },
    button: {
      padding: '3rem 6rem',
      border: 'none',
      backgroundImage:
        'linear-gradient(120deg, #a6c0fe 0%, #f68084 100%)',
      borderRadius: '30px',
      fontFamily: 'Radley',
      fontSize: '2rem',
      width: '75vw',
      margin: '0 1rem',
      fontFamily: 'body',
    },
    root: {
      body: {
        fontFamily: 'body',
      },
    },
  },
}
